import React from 'react';

type ThemeCtxProps = {
  theme: string;
  setTheme: (theme: string) => void;
};
const ThemeCtx = React.createContext<ThemeCtxProps>({
  theme: 'light',
  setTheme: () => {},
});

export const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  const [theme, setTheme] = React.useState(localStorage.theme ?? 'light');
  return (
    <ThemeCtx.Provider
      value={{
        theme,
        setTheme,
      }}
    >
      {children}
    </ThemeCtx.Provider>
  );
};

export const useTheme = () => {
  const { theme, setTheme } = React.useContext(ThemeCtx);

  const setThemeImpl = React.useCallback((theme: string) => {
    setTheme(theme);
    localStorage.setItem('theme', theme);

    document.body.classList.remove('theme-light', 'theme-dark');
    document.body.classList.add(`theme-${theme}`);

    window.dispatchEvent(new Event('themeChanged'));
  }, []);

  return {
    theme,
    setTheme: setThemeImpl,
  };
};
